import moment from "moment";

import { TIME_FORMAT } from "../constants";

/**
 * Each user's latest check-in among one day's user_activities, keyed by userId.
 * Same rule UserStatus applied to its own per-user query: the later
 * checkInTime wins and the first of two equal ones is kept.
 */
export const latestActivityByUserId = (activities) => {
  const latestByUserId = {};
  const latestCheckInTimeMomentByUserId = {};
  activities.forEach((data) => {
    const { userId } = data;
    const latestCheckInTimeMoment = latestCheckInTimeMomentByUserId[userId];
    const checkInTimeMoment = moment(data.checkInTime, TIME_FORMAT.TIME_WITH_TZ);
    if (!latestCheckInTimeMoment || latestCheckInTimeMoment.isBefore(checkInTimeMoment)) {
      latestCheckInTimeMomentByUserId[userId] = checkInTimeMoment;
      latestByUserId[userId] = data;
    }
  });
  return latestByUserId;
};
